import dashboardModule from "../vxPanelGrid.module";

dashboardModule.directive('chartPanel', function(msgBus, msgBusActions, $rootScope) {
    return {
        restrict: 'E',
        scope: {
            data: '=' // expects data to have properties: labels, datasets, and optionally options
        },
        template: `
        <div style="overflow: visible !important; position: relative !important; display: block !important;">
              <div id="tooltip-container" style="position: absolute; top: 0; left: 0; z-index: 1000; pointer-events: none; display: none; background: rgba(0,0,0,0.8); color: white; padding: 12px; border-radius: 4px; font-size: 12px; border: 1px solid rgba(255,255,255,0.3); max-width: 300px;"></div>
              <div style="overflow: visible !important; position: relative !important; width: 100% !important; height: 100% !important;">
                    <canvas class="chart chart-base"
                            ng-style="{'cursor': data.navigateData ? 'pointer' : 'default', 'overflow': 'visible !important', 'display': 'block !important'}"
                            chart-click="onClick"
                            chart-data="data.data"
                            chart-type="data.type"
                            chart-labels="data.labels"
                            chart-series="data.series"
                            chart-colors="data.colors"
                            chart-dataset-override="data.datasetOverride"
                            chart-options="data.options">
                    </canvas>
              </div>
         </div>
        `,
        link: function(scope, element) {
            // Allow tooltips to overflow canvas
            element.css({
                'overflow': 'visible',
                'position': 'relative'
            });
            
            // Find all parent divs and allow overflow
            var parent = element.parent();
            while (parent && parent.length) {
                parent.css({
                    'overflow': 'visible !important',
                    'position': 'relative'
                });
                parent = parent.parent();
                // Stop at dashboard or body level
                if (parent.hasClass('dashboard') || parent.is('body')) {
                    break;
                }
            }
            
            var tooltipContainer = element.find('#tooltip-container');
            var canvas = element.find('canvas')[0];
            var lastMouseX = 0;
            var lastMouseY = 0;
            
            // Track mouse position
            element.on('mousemove', function(e) {
                var elementRect = element[0].getBoundingClientRect();
                lastMouseX = e.clientX - elementRect.left;
                lastMouseY = e.clientY - elementRect.top;
            });
            
            // Custom tooltip callback (Chart.js 2.9.4 signature)
            var externalTooltipHandler = function(tooltipModel) {
                // Hide if no tooltip
                if (!tooltipModel || tooltipModel.opacity === 0) {
                    tooltipContainer.hide();
                    return;
                }
                
                // Get decimals from chart options (default to 0)
                var decimals = 0;
                if (scope.data && scope.data.options && scope.data.options.tooltips && typeof scope.data.options.tooltips.decimals !== 'undefined') {
                    decimals = scope.data.options.tooltips.decimals;
                }
                
                // Build tooltip HTML
                var total = 0;
                var valuesList = [];
                
                if (tooltipModel.body && Array.isArray(tooltipModel.body)) {
                    tooltipModel.body.forEach(function(bodyItem, index) {
                        var datasetLabel = tooltipModel.labelColors && tooltipModel.labelColors[index] ? tooltipModel.labelColors[index] : {};
                        var colorBox = '<span style="display: inline-block; width: 10px; height: 10px; background: ' + (datasetLabel.backgroundColor || '#ccc') + '; border-radius: 2px; flex-shrink: 0;"></span>';
                        
                        var value = bodyItem.lines && bodyItem.lines[0] ? bodyItem.lines[0] : '';
                        var label = bodyItem.label || '';
                        var displayValue = value;
                        var realValue = null;
                        
                        // Parse from string format "Label: Value"
                        var fullText = value;
                        var parts = fullText.split(':');
                        label = parts[0].trim();
                        displayValue = parts.length > 1 ? parts[1].trim() : fullText;
                        realValue = parseFloat(displayValue.replace(/[^0-9.-]/g, ''));
                        
                        // Parse numeric value for total calculation
                        if (realValue === null) {
                            realValue = parseFloat(displayValue.replace(/[^0-9.-]/g, ''));
                        }
                        if (!isNaN(realValue)) {
                            total += realValue;
                        }
                        
                        // Format display value to fixed decimals
                        var numericValue = parseFloat(displayValue.replace(/[^0-9.-]/g, ''));
                        if (!isNaN(numericValue)) {
                            displayValue = numericValue.toFixed(decimals);
                        }
                        
                        valuesList.push({
                            colorBox: colorBox,
                            label: label,
                            value: displayValue,
                            realValue: realValue
                        });
                    });
                }
                
                // Build HTML with title and total on same line
                var html = '<div style="display: flex; justify-content: space-between; align-items: center; font-weight: bold; margin-bottom: 12px;">';
                html += '<span>' + (tooltipModel.title && tooltipModel.title[0] ? tooltipModel.title[0] : '') + '</span>';
                html += '<span style="text-align: right; margin-left: 20px; font-family: monospace; font-variant-numeric: tabular-nums; min-width: 60px;">' + total.toFixed(decimals) + '</span>';
                html += '</div>';
                
                // Add values with label on left and value on right
                html += '<div style="display: flex; flex-direction: column;">';
                valuesList.forEach(function(item) {
                    html += '<div style="display: flex; align-items: center; margin-bottom: 6px; width: 100%;">';
                    html += item.colorBox;
                    html += '<span style="margin-left: 8px; flex: 1;">' + item.label + '</span>';
                    html += '<span style="text-align: right; padding-left: 8px; font-family: monospace; font-variant-numeric: tabular-nums; min-width: 60px;">' + item.value + '</span>';
                    html += '</div>';
                });
                html += '</div>';
                
                tooltipContainer.html(html);
                tooltipContainer.show();
                
                // Get tooltip width
                var containerWidth = tooltipContainer.outerWidth() || 300;
                var containerHeight = tooltipContainer.outerHeight() || 200;
                
                // Position tooltip relative to cursor position
                // Left: cursor position - width/2 - 24px (moves left)
                var top = lastMouseY - 50;
                var left = lastMouseX - (containerWidth) - 24;
                
                var elementRect = element[0].getBoundingClientRect();
                
                // Keep tooltip within bounds - flip offset when hitting left edge
                if (left < 0) {
                    // Hit left edge - flip to right side with +24px offset
                    left = lastMouseX  + 24;
                }
                
                // Keep right edge check
                if (left + containerWidth > elementRect.width) {
                    left = elementRect.width - containerWidth - 10;
                }
                
                if (top < 0) {
                    top = 10;
                }
                if (top + containerHeight > elementRect.height) {
                    top = elementRect.height - containerHeight - 10;
                }
                
                tooltipContainer.css({
                    'top': Math.max(0, top) + 'px',
                    'left': Math.max(0, left) + 'px'
                });
            };
            
            // Add custom tooltip to options
            if (!scope.data.options) {
                scope.data.options = {};
            }
            scope.data.options.tooltips = scope.data.options.tooltips || {};
            scope.data.options.tooltips.enabled = false;
            scope.data.options.tooltips.custom = externalTooltipHandler;
            
            // Handle chart click events for navigation
            scope.onClick = function(points, evt) {
                if (points && points.length > 0 && scope.data && scope.data.navigateData) {
                    var index = points[0]._index;
                    var navData = scope.data.navigateData[index];
                    if (navData && navData.type === 'jobs-month') {
                        $rootScope.$apply(function() {
                            msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                                type: 'jobs-month',
                                id: null,
                                tab: { startDate: navData.startDate, endDate: navData.endDate }
                            });
                        });
                    }
                }
            };
        }
    };
});
